import { cn } from '@/lib/utils/cn'

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent',
        className,
      )}
    />
  )
}

/**
 * Three-bar equaliser shown while a query runs. It reads as "working" rather
 * than "loading a page", which better matches a request that can take tens of
 * seconds inside the LLM pipeline.
 */
export function PulseBars({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn('bar-pulse inline-flex items-end gap-[3px]', className)}
    >
      <span className="block h-3 w-[3px] rounded-full bg-current" />
      <span className="block h-3 w-[3px] rounded-full bg-current" />
      <span className="block h-3 w-[3px] rounded-full bg-current" />
    </span>
  )
}
